import I18n from 'I18n';
// @ts-expect-error not migrated.
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import PatagoniaSidebarHeader from 'ContentEditorUI/components/sidebar/PatagoniaSidebarHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncTreeViewModuleListContainer = makeAsyncComponent(() => import(
// @ts-expect-error not migrated.
/* webpackChunkName: 'TreeViewModuleListContainer' */
'ContentEditorUI/components/sidebar/list/treeView/TreeViewModuleListContainer'));
const PatagoniaSidebarContentContainer = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PatagoniaSidebarHeader, {
      headerText: I18n.text('patagonia.sidebar.contentsHeader')
    }), /*#__PURE__*/_jsx("div", {
      className: "sidebar-scrollable-tab-panel",
      children: /*#__PURE__*/_jsx(AsyncTreeViewModuleListContainer, {})
    })]
  });
};
export default PatagoniaSidebarContentContainer;